'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import type { Address } from 'viem';
import type { UserBorrowPosition } from '@/hooks/positions/userBorrowPositionsQuery';
import { AdlAuthDetector, useAdlSunsetNudge } from '@/components/common/AdlSunsetNudge';
import { AdlSunsetNudgeDialog } from '@/components/common/Dialog';
import { useWeb3Context } from '@/contexts/Web3Context';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';
import { useFeatureFlags } from '@/lib/shared/components/FeatureFlagsProvider';
interface AdlSunsetNudgeWatcherProps {
  borrowPositions: UserBorrowPosition[];
}
const DISMISSED_KEY_PREFIX = 'morpho.adl-sunset-nudge-dismissed.';
const AdlSunsetNudgeWatcher = t0 => {
  const $ = _c(3);
  const {
    borrowPositions
  } = t0;
  const {
    account
  } = useWeb3Context();
  const {
    isSelf
  } = useViewedAccountAddress();
  const {
    autoDeleverage
  } = useFeatureFlags();
  if (!isSelf || !account.isConnected || !account.address) {
    return null;
  }
  if (!autoDeleverage) {
    return null;
  }
  if (borrowPositions.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== account.address || $[1] !== borrowPositions) {
    t1 = <AdlSunsetNudgeWatcherInner key={account.address} borrowPositions={borrowPositions} address={account.address} />;
    $[0] = account.address;
    $[1] = borrowPositions;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
interface AdlSunsetNudgeWatcherInnerProps {
  borrowPositions: UserBorrowPosition[];
  address: Address;
}
const AdlSunsetNudgeWatcherInner = t0 => {
  const $ = _c(11);
  const {
    borrowPositions,
    address
  } = t0;
  let t1;
  if ($[0] !== address) {
    t1 = address.toLowerCase();
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${DISMISSED_KEY_PREFIX}${t1}`;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      dismissalKey: t2,
      source: "dashboard",
      renderDialog: _temp
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    dismissed,
    requestOpen
  } = useAdlSunsetNudge(t3);
  if (dismissed) {
    return null;
  }
  let t4;
  if ($[4] !== borrowPositions || $[5] !== requestOpen) {
    let t5;
    if ($[7] !== requestOpen) {
      t5 = position => <AdlAuthDetector key={`${position.market.chainId}-${position.market.marketId}`} marketId={position.market.marketId as MarketId} chainId={position.market.chainId as ChainId} onAuthorized={requestOpen} />;
      $[7] = requestOpen;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = borrowPositions.map(t5);
    $[4] = borrowPositions;
    $[5] = requestOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <>{t4}</>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default AdlSunsetNudgeWatcher;
function _temp() {
  return <AdlSunsetNudgeDialog source="dashboard" />;
}